import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { IThemeSafetyNet } from '../../Models';

interface IFaqThemeWidgetProps {
    themes: IThemeSafetyNet[];
    currentThemeId: number;
    onClick: (id: number) => void;
    coloredFaq: boolean;
}

export class SafetyNetThemeListWidget extends Component<
    IFaqThemeWidgetProps,
    any
> {
    constructor(props: IFaqThemeWidgetProps) {
        super(props);
    }

    handleClick(themeId: number) {
        this.props.onClick(themeId);
    }

    themeTitle(title: string | undefined): string {
        return title != null ? title : '';
    }

    render() {
        return (
            <div className="tab__filters safetynet">
                {this.props.themes.map((theme) => {
                    let borderSelected = {} as React.CSSProperties;
                    if (!this.props.coloredFaq) {
                        borderSelected =
                            theme.id === this.props.currentThemeId
                                ? ({
                                      border: '3px solid #002d5d',
                                  } as React.CSSProperties)
                                : ({
                                      border: '3px solid #f3f4f4',
                                  } as React.CSSProperties);
                    }
                    const themeClass =
                        theme.id === this.props.currentThemeId ? 'active ' : '';
                    return (
                        <div
                            key={'theme' + theme.id}
                            className="filter_wrapper col-lg-4 col-12"
                        >
                            <a
                                key={'theme' + theme.id}
                                className={themeClass}
                                style={borderSelected}
                                onClick={() => this.handleClick(theme.id)}
                            >
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: this.themeTitle(theme.title),
                                    }}
                                />
                            </a>
                        </div>
                    );
                })}
            </div>
        );
    }
}

WidgetHelper.register(SafetyNetThemeListWidget, 'safety-net-theme-list-widget');
